export default __webpack_public_path__ + "static/media/Group 6.7d437fd2.png";